import { PayloadAction } from '@reduxjs/toolkit';

import { initialState } from 'store/slice/pdpStateSlice';
import {
  BigBuyBarView,
  IMiscData,
  IPDPState,
  IWindowPosition,
  MobileView,
} from 'store/types/pdpStateTypes';
import { IProduct } from 'shared/types/Product';
import { IProductSearch } from 'shared/types/ProductSearch';

export const addWindow = (state: IPDPState, action: PayloadAction<IProduct | IProductSearch>) => {
  const { payload } = action;
  const newWindow = { ...payload, ...{ positionOffset: state.positionOffset } };

  if (!state.openWindows.some((window) => window.id === payload.id)) {
    state.openWindows = [...state.openWindows, newWindow];
    state.positionOffset += 24;
  }
};

export const removeWindow = (
  state: IPDPState,
  action: PayloadAction<IProduct | IProductSearch>,
) => {
  const { id } = action.payload;
  state.openWindows = state.openWindows.filter((window) => window.id !== id);
  state.positionOffset -= 24;
};

export const resetWindows = (state: IPDPState) => ({ ...initialState, size: state.size });

export const setInitialCategoryWindowPosition = (
  state: IPDPState,
  action: PayloadAction<{ title: string; position: IWindowPosition }>,
) => {
  const { title, position } = action.payload;
  state.initialCategoryWindowPosition = {
    ...state.initialCategoryWindowPosition,
    ...{ [title]: position },
  };
};

export const setBigBuyBarView = (state: IPDPState, action: PayloadAction<BigBuyBarView>) => {
  state.bigBuyBarView = action.payload;
};

export const setMobileView = (
  state: IPDPState,
  action: PayloadAction<{ size: number; view: MobileView }>,
) => {
  const { view, size } = action.payload;
  state.previousMobileView = state.mobileView;
  state.mobileView = view;
  state.size = size;
};

export const setWindowFocus = (state: IPDPState, action: PayloadAction<string>) => {
  state.focusedWindow = action.payload;
};

export const setSize = (state: IPDPState, action: PayloadAction<number>) => {
  state.size = action.payload;
};

export const updateMisc = (
  state: IPDPState,
  action: PayloadAction<{ key: string; data: IMiscData }>,
) => {
  const { key, data } = action.payload;
  state.misc = {
    ...state.misc,
    [key]: {
      ...state.misc[key],
      ...data,
    },
  };
};

export const clearMisc = (state: IPDPState, action: PayloadAction<string>) => {
  const newMisc = { ...state.misc };
  delete newMisc[action.payload];
  state.misc = newMisc;
};
